import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { JoinPremiumBundleFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { PremiumOfferCard } from '../PremiumOfferCard'
import { PremiumBundleAvatarList } from './PremiumBundleAvatarList'

interface Props {
  currency?: string
  bundle: JoinPremiumBundleFragment
}

export const PremiumBundleCard = ({ bundle, currency = 'USD' }: Props) => {
  // TODO: find currency for company suscription
  const { access } = useCurrentSession()
  const bundlePricing = bundle.prices.find((price) => price.currencyCode === currency)
  const isBooked = bundle.isBooked

  // If no pricing we won't be showing the card
  // to prevent bad price charging
  if (!bundlePricing) return null

  const formatPrice = (amount: number) => {
    return new Intl.NumberFormat(access.locale, {
      style: 'currency',
      currency: bundlePricing.currencyCode,
      minimumFractionDigits: 2,
    }).format(amount / 100)
  }

  const hasDiscount = bundlePricing.reducedPercentage > 0
  const originalAmount = formatPrice(bundlePricing.originalAmount)
  const bundlePrice = hasDiscount
    ? formatPrice(bundlePricing.reducedAmount)
    : formatPrice(bundlePricing.originalAmount)

  return (
    <PremiumOfferCard
      heading={<PremiumBundleAvatarList bundle={bundle} />}
      body={
        <Box gap="s12" flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal color="grey1000" size="300" weight="semibold">
            {bundle.name}
          </Text.Normal>

          {isBooked && (
            <Tag inline type="correct" showCircle leftItem="circle" size="small">
              Booked
            </Tag>
          )}
        </Box>
      }
      footer={
        <>
          <Box flexDirection="row" gap="s6">
            {hasDiscount ? (
              <>
                <Text.Normal size="200" color="grey1000" weight="semibold">
                  {bundlePrice}
                </Text.Normal>
                <Text.Normal size="200" color="grey700" weight="semibold" stroked>
                  {originalAmount}
                </Text.Normal>
                <Tag inline leftItem="circle" type="correct" size="small">
                  -{bundlePricing.reducedPercentage}%
                </Tag>
              </>
            ) : (
              <Text.Normal size="200" color="grey1000" weight="semibold">
                {originalAmount}
              </Text.Normal>
            )}
          </Box>

          {/* TODO: add modal on button click */}
          <Button
            variant="outline"
            label={i18n.t('ats.job_details.premium_portals.bundles.buy_button')}
            onClick={() => true}
            disabled={isBooked}
          />
        </>
      }
    />
  )
}
